var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChange = function SvgChange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.234 10.745c.66 0 1.212.553 1.212 1.234v1.404c0 3.319-2.702 6.042-6.042 6.042H9.085v1.766c0 .404-.213.788-.574.979-.17.085-.34.128-.532.128-.213 0-.405-.043-.596-.17l-4.68-3.001a1.086 1.086 0 0 1-.511-.936c0-.382.191-.723.51-.936l4.681-3a1.117 1.117 0 0 1 1.149-.043c.361.192.574.576.574.98v1.786l6.298.001A3.605 3.605 0 0 0 19 13.384v-1.405c0-.68.553-1.234 1.234-1.234zm-4.766-8.512c.362-.192.808-.17 1.149.043l4.68 3c.32.213.512.575.511.958 0 .383-.191.723-.51.936l-4.681 3c-.17.107-.383.17-.596.17a1.22 1.22 0 0 1-.532-.127 1.102 1.102 0 0 1-.574-.98V7.426H8.618a3.605 3.605 0 0 0-3.595 3.596v1.404a1.235 1.235 0 0 1-2.469 0v-1.404c0-3.319 2.702-6.042 6.043-6.042h6.298V3.212c0-.404.213-.787.574-.979z",
    fill: "#292A2C",
    fillRule: "evenodd"
  })));
};

export default SvgChange;